import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import appRoutes from '../../../../../../../../app-routes';
import {
  UserRoles,
  NOTIFICATION_MODULE_MENU_LABEL,
} from '../../../../../../../../constraints';

import useFilters from '../../../../../../../../hooks/useFilters';

// Components
import { ProtectedComponent } from '../../../../../../../Auth/components';
import * as Styled from './styled';

const CreateTemplateForm = () => {
  const { filters, navigateWithNewSearchQuery } = useFilters();

  const handleCreateClick = () => {
    navigateWithNewSearchQuery(
      { ...filters },
      appRoutes.NOTIFICATION_TEMPLATE_CREATOR,
    );
  };

  return (
    <ProtectedComponent
      roles={[UserRoles.BUSINESS_ADMIN, UserRoles.ADMIN]}
      render={false}
    >
      <Styled.ButtonCol sm={10} md={4}>
        <Styled.HeaderButton fontWeight={500} onClick={handleCreateClick}>
          <FormattedMessage
            id={NOTIFICATION_MODULE_MENU_LABEL.TEMPLATE_CREATE_BUTTON}
            defaultMessage={
              NOTIFICATION_MODULE_MENU_LABEL.TEMPLATE_CREATE_BUTTON
            }
          />
        </Styled.HeaderButton>
      </Styled.ButtonCol>
    </ProtectedComponent>
  );
};

export default CreateTemplateForm;
